import './fontSizeSwitch.scss';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { AppContext } from '../../context/appContext';
import langIcon from './images/language.png';
import rightIcon from '../../images/arrow-right.png';
import { fontSizeSwitchList } from './constants';
import { EFontSize } from '../../interface/fontSize';
import { setFontSize } from '../../services/fontSizeService';
import LangCache from '../../base/langCache';
import { getCurrentFontSize } from '../../../../businessCommon/src/@utils/fontSize';

interface IFontSizeSwitchProps {
    loginCardRef?: React.RefObject<HTMLDivElement>;
}

export const FontSizeSwitch = React.memo((props: IFontSizeSwitchProps) => {
    const { loginCardRef } = props;
    const { state } = useContext(AppContext);
    const [unfold, setUnfold] = useState(false);
    const options = fontSizeSwitchList;
    const currentSwitchRef = useRef<HTMLDivElement>(null);
    const LANG = LangCache.getLang();

    const onClick = () => {
        setUnfold(!unfold);
    };

    useEffect(() => {
        // 在点击字号切换时，滚动到当前语言选项
        if (!unfold) {
            return;
        }
        if (!currentSwitchRef?.current || !loginCardRef?.current) {
            return;
        }
        loginCardRef.current?.scrollTo({
            top: currentSwitchRef.current.offsetTop,
            behavior: 'smooth',
        });
    }, [unfold]);

    const onFontSizeChange = (value: string) => {
        setFontSize(value).then(() => {
            window.location.reload();
        });
    };

    const currentFontSize = getCurrentFontSize() || EFontSize.SMALL;
    const currentFontSizeValue = options.find((item) => item.key === currentFontSize)?.value || options[0].value;

    return (
        <div className="font-size-switch-wrap" ref={currentSwitchRef}>
            <div className="current-font-size" onClick={onClick}>
                <img className="lang-icon" src={langIcon} />
                <span className="lang-text">{LANG[currentFontSizeValue]}</span>
                <img className={`lang-arrow ${unfold ? 'arrow-down' : ''}`} src={rightIcon} />
            </div>
            {unfold && (
                <div className="dropdown-menu">
                    {options.map((item) => (
                        <div
                            key={item.key}
                            className="font-size-option"
                            onClick={() => {
                                onFontSizeChange(item.key);
                            }}
                        >
                            {LANG[item.value]}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
});
